<template>
  <div
    class="group__info margin-top-10 margin-bottom-10 padding-bottom-10"
    v-if="relationDocs && relationDocs.length"
  >
    <div class="title font-size__medium">{{ title }}</div>
    <div class="ctn">
      <template>
        <el-table
          class="table detailRelatedDocs"
          :data="relationDocs"
          style="max-width: 100%; width: 100%;"
          size="mini"
        >
          <el-table-column label="Trích yếu" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="docName flex-row flex__left margin-right-10">
                <file-type-image
                  :custom-class="''"
                  :file-extention="scope.row.fileExtention"
                >
                </file-type-image>
                <a
                  class="txt style-fullWidth margin-left-10 color__black clickable"
                  @click="downloadFile(scope.row)"
                >
                  {{ scope.row.quote || "-" }}
                </a>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Loại văn bản"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ getRelationTypeLabel(scope.row.relationType) || "-" }}
            </template>
          </el-table-column>

          <el-table-column label="Số ký hiệu" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.docCode || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            label="Ngày văn bản"
            width="135"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
              scope.row.docDate
              | dateFormatter({ dateFormat: "DD/MM/YYYY", nullValue: "-" })
              }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="checkIsSignEnable"
            label="Yêu cầu ký số"
            align="center"
            width="135"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkedSignCA" disabled :style="{marginRight: 0}" />
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
  </div>
</template>

<script>
  import docRelationService from "../../services/docRelationService";
  import h from "../../services/h";
  import constants from "../../constants";
  import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
  import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
  import dateFormatter from "../../filters/dateFormatter";
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import FileTypeImage from "../common/FileTypeImage";
  import categoryViewService from "../../services/categoryViewService";
  import downloadService from "../../services/downloadService";
  import attachmentService from "../../services/attachmentService";

  export default {
    name: "doc-relations-detail",
    props: ["attachedType", "docId", "title"],
    filters: {dateFormatter, buildAttachmentURL, convertToLabelFilter},
    components: {
      FileTypeImage
    },

    data() {
      return {
        DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
        DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
        relationDocs: [],
        docRelationTypes: [],
        DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED,
        checkIsSignEnable: true,
      };
    },

    computed: {
      userVbOutgoingProcessId() {
        return this.$route.query.vbDocProcessId;
      },

      isVinataba() {
        return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABA;
      },
    },

    created() {
      if(!this.isVinataba)
      {
        this.checkIsSignEnable = this.attachedType === constants.DOC_RELATION_ATTACHED_TYPE.ATTACHED;
      }
      else {
        this.checkIsSignEnable = true
      }
      this.loadCategories();
      this.loadRelationDocs();
    },

    watch: {
      docId() {
        this.loadRelationDocs();
      }
    },

    methods: {
      loadRelationDocs() {
        this.relationDocs = [];
        if (!this.docId) return;
        return docRelationService
          .findAll({objectId: this.docId, attachedType: this.attachedType})
          .then(response => {
            h.each(response.data, item => {
              this.relationDocs.push({
                id: item.id,
                objectRelateToId: item.objectRelateToId,
                docCode: item.docCode,
                quote: item.quote,
                docDate: item.docDate,
                objectTypeRelateTo: item.objectTypeRelateTo,
                relationType: item.relationType,
                attachedType: item.attachedType,
                checkedSignCA: item.checkedSignCA
              });
            });
          });
      },

      getRelationTypeLabel(relationType) {
        let docRelationType = h.find(
          this.docRelationTypes,
          docRelationType => docRelationType.id === relationType
        );
        return docRelationType ? docRelationType.categoryName : null;
      },

      loadCategories() {
        return categoryViewService
          .findAll(
            {groupCode: constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE},
            {page: 0, size: 1000}
          )
          .then(response => (this.docRelationTypes = response.data));
      },

      downloadFile(docRelation) {
        switch (docRelation.objectTypeRelateTo) {
          case constants.DOC_RELATION_OBJECT_TYPE.ATTACHMENT:
            downloadService.downloadFileCommon(
              attachmentService.findByObjectIdAndObjectType(docRelation.id, constants.ATTACHMENT_OBJECT_TYPE.VB_DI_DINH_KEM_SIGNED_WITH_TOKEN)
              .then(res => {
                if (res.data.length > 0) {
                  return vbAttachmentTokenService.getToken(res.data[0].id).then(token => token.data)
                } else {
                  return attachmentService.findByObjectIdAndObjectType(docRelation.id, constants.ATTACHMENT_OBJECT_TYPE.FILE_BAN_HANH_CO_CHU_KY_PDF)
                  .then(res2 => {
                    return vbAttachmentTokenService.getToken(res2.data[0].id).then(token => token.data)
                  })
                }
              })
              .catch(() => {
                return vbAttachmentTokenService
                  .getToken(docRelation.objectRelateToId)
                  .then(response => response.data)
              }),
              constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            );

            // downloadService.downloadFileCommon(
            //   vbAttachmentTokenService
            //     .getToken(docRelation.objectRelateToId)
            //     .then(response => response.data),
            //   constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            // );
            break;
          case constants.DOC_RELATION_OBJECT_TYPE.OUTGOING_DOC:
          case constants.DOC_RELATION_OBJECT_TYPE.VB_DEN:
            downloadService.downloadFileCommon(
              vbAttachmentTokenService
                .getTokenDocRelation(docRelation.id)
                .then(response => response.data),
              buildAttachmentURL({type: constants.DOWNLOAD_OPTION.TYPE.PDF})
            );
            break;
        }
        console.log('- END - Download van ban dinh kem')
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/doc-relations-detail.vue